import { z } from 'zod';

export enum PromptType {
  ENCOURAGEMENT = 'ENCOURAGEMENT',
}

const EncouragementPromptMetadataSchema = z.object({
  characterType: z.string(),
  correctAttempts: z.number().nonnegative(),
  attemptCount: z.number().nonnegative(),
  history: z.string(),
  name: z.string(),
  age: z.number(),
  ageGroup: z.string(),
});

export type EncouragementPromptMetadata = z.infer<typeof EncouragementPromptMetadataSchema>;

export const PromptOptionsSchema = z.discriminatedUnion('promptType', [
  z.object({
    promptType: z.literal(PromptType.ENCOURAGEMENT),
    metadata: EncouragementPromptMetadataSchema,
  }),
]);

export type PromptOptions = z.infer<typeof PromptOptionsSchema>;
